import get from 'lodash.get';

import messageEvents from 'events/messages';
import { getMessageById } from 'app/modules';

export default function handlePaymentMessageSuccess(message) {
  // Logic to combine different CC messages together by changing the messageID
  // to the payment ID and effectively overwrite previous messages.
  // This is done because status requests for a single payment item are being
  // sent as multiple messages due to API limitations
  return (dispatch, getState) => {
    const paymentId = get(message, 'content.paymentId', '');
    if (paymentId === '') {
      throw new Error('no paymentId found for payment message');
    }

    // keep track of original message IDs
    message.originalIds = [message.id];

    message.id = paymentId;
    const existingMessage = getMessageById(getState(), paymentId);
    if (existingMessage) {
      // if existing message timestamp is after incoming message timestamp
      // update the existing message timestamp to keep the earliest date
      // and keep content for the payment item the same
      if (existingMessage.date > message.date) {
        existingMessage.date = message.date;
        existingMessage.originalIds = existingMessage.originalIds.concat(message.originalIds);
        dispatch(messageEvents.createOrUpdateMessageSuccess(existingMessage));
        return;
      }

      // if existing message timestamp is before incoming message
      // update timestamp on the incoming message
      message.date = existingMessage.date;
      message.originalIds = message.originalIds.concat(existingMessage.originalIds);
    }

    // use the incoming message content for the payment item
    dispatch(messageEvents.createOrUpdateMessageSuccess(message));
  };
}
